import React, { useState, useMemo } from 'react';

import moment from 'moment';

import { Report } from '~/components';
import {
  DateTime,
  Autocomplete,
  Input,
  RadioGroup,
  MultiAutocomplete,
  Checkbox,
  Select,
} from '~/components/Form';
import { CRUDProfile, PesquisaTabela } from '~/components/Form/v2';
import { REL_RECEBIMENTO } from '~/constants/default';
import { t } from '~/helpers';

function Relrecebimentonf() {
  const [open, setOpen] = useState(true);
  const [valuePosto, setValuePosto] = React.useState(0);
  const [exibeExibirMedidores, setExibeExibirMedidores] = useState(true);

  const start = moment()
    .subtract({ day: 7 })
    .set({ hour: 0, minute: 0, second: 0 });
  const end = moment().set({ hour: 23, minute: 59, second: 59 });

  const cellsUser = useMemo(
    () => [
      {
        id: 'codigousuario',
        label: t('s.cadastro.usuario.codigousuario'),
        filter: { type: 'text' },
      },
      {
        id: 'nomeusuario',
        label: t('s.cadastro.usuario.nomeusuario'),
        filter: { type: 'text' },
      },
    ],
    []
  );

  const orderoptions = [
    { value: 'LI', label: t('s.relatorio.abastecimento.opcaolistagem') },
    { value: 'PC', label: t('s.relatorio.abastecimento.opcaopostocomboio') },
    { value: 'DT', label: t('s.relatorio.abastecimento.opcaodata') },
    { value: 'PD', label: t('s.relatorio.abastecimento.opcaoproduto') },
    { value: 'TP', label: t('s.relatorio.descarga.transportadora') },
    { value: 'PL', label: t('s.operacao.recebimento.placactdescarga') },
    { value: 'MT', label: t('s.relatorio.descarga.motorista') },
    { value: 'US', label: t('s.relatorio.descarga.usuario') },
  ];

  function handleSerializeForm(params) {
    const idPosto =
      valuePosto === 0 ? '' : valuePosto?.map((posto) => posto.idposto);

    return {
      ...params,
      idposto: idPosto,
      idproduto: params.idproduto || '',
      exibetanques: params.exibetanques ? '1' : '0',
    };
  }

  return (
    <Report
      open={open}
      onClose={() => setOpen(false)}
      title={t('s.relatorio.recebimento')}
      relatorio="recebimentonf"
      serialize={(param) => handleSerializeForm(param)}
      initials={{
        datahorainicial: start.format('DD/MM/YYYY HH:mm:ss'),
        datahorafinal: end.format('DD/MM/YYYY HH:mm:ss'),
        tipoordenacaoreport: 'LI',
        idperfilrelatorio: '0',
      }}
    >
      <DateTime
        label={t('s.geral.opcoes.datahorainicial')}
        name="datahorainicial"
        serialize={(value) =>
          value.set({ seconds: 0 }).format('DD/MM/YYYY HH:mm:ss')
        }
        time
      />

      <DateTime
        label={t('s.geral.opcoes.datahorafinal')}
        name="datahorafinal"
        serialize={(value) =>
          value.set({ seconds: 0 }).format('DD/MM/YYYY HH:mm:ss')
        }
        time
      />

      <MultiAutocomplete
        multiple
        name="idposto"
        label="codigonomeposto"
        url="postoscomboios"
        unique="idposto"
        title={t('s.geral.postocomboio')}
        hiddens={[{ name: 'codigonomeposto' }]}
        getValue={(value) => {
          if (value[0]?.idposto !== null) {
            setValuePosto(value);
          }
        }}
      />

      {/*   <Autocomplete
        name="unidadecomboio"
        label="codigonomeposto"
        url="postoscomboios"
        unique="idposto"
        title={t('s.geral.postocomboio')}
        defaultValue=""
        hiddens={[{ name: 'nomeposto' }, { name: 'idposto' }]}
      /> */}

      <Autocomplete
        name="idproduto"
        label="nomeproduto"
        url="produtos"
        unique="idproduto"
        title={t('s.menu.configuracao.produto')}
        defaultValue=""
        hiddens={[{ name: 'nomeproduto' }, { name: 'idproduto' }]}
      />

      <Input name="placactdescarga" label={t('s.menu.cadastro.placact')} />

      <Input name="numeronfdescarga" label={t('s.menu.cadastro.numeronf')} />

      <PesquisaTabela
        name="codigousuario"
        label={t('s.relatorio.abastecimentocontingencia.frentista')}
        primary="codigousuario"
        secondary="nomeusuario"
        url="usuarios"
        header={cellsUser}
      />

      <Input
        name="distribuidora"
        label={t('s.relatorio.geral.distribuidora')}
      />

      <Input
        name="transportadora"
        label={t('s.relatorio.geral.transportadora')}
      />

      <Select
        name="tipoordenacaoreport"
        variant="outlined"
        size="small"
        label={t('s.relatorio.abastecimento.tipoordenacao')}
        options={orderoptions}
      />

      <CRUDProfile
        name="idperfilrelatorio"
        label={t('s.menu.cadastro.usuario.perfil')}
        report={REL_RECEBIMENTO}
        nameReport={t('s.menu.operacao.recebimento')}
        onChange={(value) => {
          setExibeExibirMedidores(value == 0);
        }}
      />

      {exibeExibirMedidores && (
        <Checkbox
          name="exibetanques"
          label={t('s.relatorio.recebimentonf.exibemedidores')}
        />
      )}

      <RadioGroup
        name="formato"
        label={t('s.relatorio.geral.formato')}
        options={[
          { label: 'PDF', value: 'pdf' },
          { label: 'Excel', value: 'excel' },
        ]}
        defaultValue="pdf"
        serialize={(value) => value}
        row
      />
    </Report>
  );
}

export default Relrecebimentonf;
